<p>my-alerts-configurations works!</p>